import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { baseUrls } from './appConstant';
import { BehaviorSubject, of, Subject, Subscription } from 'rxjs';
import { ApiService } from './api.service';
import { SubscriptionPlanService } from './services/subscription-plan.service';
declare var $: any;

@Injectable()
export class GlobalServices {
  public viewcontainerhelper: any;
  public headerviewcontainerhelper: any;
  public headercrf: any;
  public signupPage: object = {};
  public isBrowser: boolean;
  public priceCheck: any;
  isLoggedIn = false;
  userDetails: any;
  public cartquantity = 0;
  cameFrom = '';
  public firstname = '';
  public signupType: string;
  public imgSrc = '';
  public signupStatus: boolean = false;
  public direcPaymentPage: boolean = false;
  public subjectTriggerForLoginDetectAtHeader = new Subject<any>();
  public subjectTriggerForPlanPage = new Subject<any>();
  public signupTriggerForSignupPage = new BehaviorSubject<any>(false);
  moveToPlanPage = new Subject<any>();
  hideHeader = new BehaviorSubject<any>(false);
  hideFooter = new Subject<any>();
  mode: string;

  constructor(
    @Inject(PLATFORM_ID) platformId: string,
    private apiService: ApiService,
    private subscriptionPlanService: SubscriptionPlanService,
    public httpService: ApiService,
  ) {
    if (isPlatformBrowser(platformId)) {
      // this.checkCookie();
      this.isBrowser = true;
      this.userDetail();
      if (Number(localStorage.getItem('cartquantity')) >= 0 && localStorage.getItem("cartquantity") !== null) {
        this.cartquantity = Number(localStorage.getItem('cartquantity')) + 1;
      } else {
        this.cartquantity = 0;
      }
      if (Number(localStorage.getItem("isActivePlan")) >= 0) {
        this.isActivePlan = Number(localStorage.getItem("isActivePlan")) >= 0 ? Number(localStorage.getItem("isActivePlan")) : undefined;
      }
    } else {
      this.isBrowser = false;
    }
  }
  public async triggerlogin(viewcontain, cfr) {
    viewcontain.clear();
    const { LoginComponent } = await import('./login/login.component');
    return viewcontain.createComponent(
      cfr.resolveComponentFactory(LoginComponent)
    );
  }
  public userDetail() {
    if (this.isBrowser) {
      if (localStorage.getItem('userDetails')) {
        this.isLoggedIn = true;
        this.userDetails = JSON.parse(localStorage.getItem("userDetails"));
        this.firstname = this.userDetails ? this.userDetails.firstName : '';
        this.imgSrc = this.userDetails && this.userDetails['images'] && this.userDetails['images']['path'] ? baseUrls['images'] + this.userDetails['images']['path'] + this.userDetails['images']['name'] : 'assets/images/profile-picture.png';
      }
      else {
        this.isLoggedIn = false;
      }
    }
  }
  public async triggersignup(viewcontain, cfr) {
    viewcontain.clear();
    const { SignupComponent } = await import('./signup/signup.component');
    return viewcontain.createComponent(
      cfr.resolveComponentFactory(SignupComponent)
    );
  }

  public async triggerpartnersignup(viewcontain, cfr) {
    viewcontain.clear();
    const { PartnersignupComponent } = await import('./partnersignup/partnersignup.component');
    return viewcontain.createComponent(
      cfr.resolveComponentFactory(PartnersignupComponent)
    );
  }

  public async triggerforgotpass() {
    this.viewcontainerhelper.clear();
    const { ForgotpassComponent } = await import('./forgotpass/forgotpass.component');
    return this.headerviewcontainerhelper.createComponent(
      this.headercrf.resolveComponentFactory(ForgotpassComponent)
    );
  }
  public async triggerforgotpassNew(viewcontainerhelper, componentFactoryResolver) {
    viewcontainerhelper.clear();
    const { ForgotpassComponent } = await import('./forgotpass/forgotpass.component');
    return viewcontainerhelper.createComponent(
      componentFactoryResolver.resolveComponentFactory(ForgotpassComponent)
    );
  }
  createTabs() {
    if (this.isBrowser) {
      $('ul.tabs li').click(function () {
        var tab_id = $(this).attr('data-tab');
        $('ul.tabs li').removeClass('current');
        $('.tab-content').removeClass('current');
        $(this).addClass('current');
        $("#" + tab_id).addClass('current');
      });
      $(".acoord-tittle").click(function () {
        $(this).next(".acoord-display").slideToggle();
        $(this).toggleClass("active");
        $(this).parent().toggleClass("active");
      });
    }
  }

  scroller() {
    if (this.isBrowser) {

      // handle links with @href started with '#' only
      $(document).on('click', 'a[href^="#"]', function (e) {
        var demoClasses = document.querySelectorAll('.active');
        demoClasses.forEach(element => {
          element.setAttribute('class', 'btn');
        });
        // target element id
        $(this).toggleClass('active');
        var id = $(this).attr('href');

        // target element
        if (id !== '#') {
          var $id = $(id);
          if ($id.length === 0) {
            return;
          }

          // prevent standard hash navigation (avoid(0) blinking in IE)
          e.preventDefault();

          // top position relative to the document
          var pos = $id.offset().top;
          // console.log(pos - 100);

          // animated top scrolling
          $('body, html').animate({ scrollTop: pos - 100 });
        }

      });
    }
  }

  scrollbar() {
    if (this.isBrowser) {
      $('.scrollBox').mCustomScrollbar({
        axix: "y"
      });
    }
  }
  opensignuppage() {
    if (this.isBrowser)
      location.href = baseUrls.hostedUrl + "register/5f3a332be019a9049b0ee8b5-monthly";
  }
  public wishlistStatus: boolean = false;
  public wishList(type, programId, platformTypePassed) {
    if (this.isLoggedIn) {
      if (this.userDetails) {
        let user_id = this.userDetails['_id'];
        let url = "user/save-wishlist";
        let obj = { programId, userId: user_id, platformType: type, platform: platformTypePassed };
        return this.apiService.postFormData(url, obj);
      }
      return of();
    }
    return of();
  }
  checkCookie() {
    if (this.isBrowser) {
      if (navigator.cookieEnabled) {

      }
      else {
        this.showCookieFail();
      }
    }
  }
  showCookieFail() {
    // do something here
    alert('Please allow cookies from browser for better experience !!');
  }
  toFormData<T>(formValue: T) {
    const formData = new FormData();
    for (const key of Object.keys(formValue)) {
      const value = formValue[key];
      formData.append(key, value);
    }
    return formData;
  }
  isActivePlan;
  userActivityLog;
  isActivePlanUserHave() {
    this.apiService.getuserDataWithToken("user/info").subscribe((responseOfUser: any) => {
      if (responseOfUser) {
        if (responseOfUser?.userObj?.isActivePlan >= 0) {
          this.isActivePlan = responseOfUser?.userObj?.isActivePlan;
          this.userActivityLog = responseOfUser?.userObj?.userActivityLog;
          localStorage.setItem("isActivePlan", responseOfUser?.userObj?.isActivePlan);
          localStorage.setItem('userActivityLog', JSON.stringify(responseOfUser?.userObj?.userActivityLog));
        }
      }
    })
  }
  postUserActivityLog(objectPassed) {
    this.apiService.postuserDataWithToken("user/activity-log", objectPassed).subscribe((responseOfUser: any) => {
      if (responseOfUser) {
      }
    })
  }
  planId;
  getSubscriptionPlan() {
    this.subscriptionPlanService.getSubscriptionDetail().subscribe((response: any) => {
      if (response?.data?._id) {
        this.planId = response?.data?._id;
        localStorage.setItem("planId", response?.data?._id);
      }
    });
  }

  logout() {
    if (this.isBrowser) {
      this.userDetails = localStorage.getItem("userDetails") ? JSON.parse(localStorage.getItem("userDetails")) : null;

      let urlForgotPassword = "user/logout";
      this.mode = 'indeterminate';
      let data = { userId: this.userDetails ? this.userDetails['_id'] : null };
      this.httpService.postFormData(urlForgotPassword, data).subscribe(response => {
        if (response.success) {
          this.isLoggedIn = false;
          let quantity = Number(localStorage.getItem('cartquantity'));
          while (quantity > -1) {
            localStorage.removeItem('cartdata_' + quantity);
            quantity = quantity - 1;
          }
          this.cartquantity = 0;
          localStorage.removeItem('cartquantity');
          localStorage.removeItem('userDetails');
          localStorage.removeItem('userToken');
          localStorage.removeItem("userEmail");
          localStorage.removeItem("userPass");
          localStorage.removeItem('planpayment');
          localStorage.removeItem('dataArray');
          localStorage.removeItem('moveToPlanPage');
          localStorage.removeItem('userSubscriptionPlan');
          localStorage.removeItem('userActivityLog');
          localStorage.removeItem('isActivePlan');
          localStorage.removeItem('planpayment');
          localStorage.removeItem('userSubscribeInfo');
          window.location.href = '/';
        }
        localStorage.removeItem('dataArray');
        localStorage.removeItem('userDetails');
        localStorage.removeItem('userToken');
        localStorage.removeItem('isPlanActive');
        this.mode = 'indeterminate';
      });
    }
  }


}
